module.exports = require("github:jspm/nodelibs-util@0.1.0/index");